<vg-vgn-nav [no-nav]="'4'" app-id="change-of-ownership-angular">
  <main class="main">
    <div id="focus-element">
      <c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
      <router-outlet></router-outlet>
    </div>
  </main>
</vg-vgn-nav>
